/** Shared per-logical-page scroll depth for scroll_depth events and page_engagement payloads. */

let maxScrollPercent = 0;

export function resetPageMetrics(): void {
  maxScrollPercent = 0;
}

export function getMaxScrollPercent(): number {
  return maxScrollPercent;
}

export function measureScrollDepthPercent(): number {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }
  const doc = document.documentElement;
  const scrollTop = window.scrollY || doc.scrollTop;
  const max = Math.max(1, doc.scrollHeight - window.innerHeight);
  return Math.min(100, Math.round((scrollTop / max) * 100));
}

export function updateMaxScrollFromCurrentPosition(): number {
  const depth = measureScrollDepthPercent();
  if (depth > maxScrollPercent) {
    maxScrollPercent = depth;
  }
  return depth;
}
